import { render, staticRenderFns } from "./resultat-crp.html?vue&type=template&id=08091d15&scoped=true&external"
import script from "./resultat-crp.js?vue&type=script&lang=js&external"
export * from "./resultat-crp.js?vue&type=script&lang=js&external"
import style0 from "./resultat-crp.scss?vue&type=style&index=0&id=08091d15&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08091d15",
  null
  
)

export default component.exports